import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled, { keyframes } from 'styled-components';
import { NUMBER_OF_RINGS } from './Logo.contants.js';

var _templateObject, _templateObject2, _templateObject3;
var DURATION = 2;
var progress = function progress(_ref) {
  var $circumference = _ref.$circumference;
  var halfCircle = $circumference / 2;
  return keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    0% {\n      stroke-dasharray: 0, ", ";\n      stroke-dashoffset: 0;\n    }\n    30% {\n      stroke-dasharray: ", ", ", ";\n      stroke-dashoffset: 0;\n    }\n    70% {\n      stroke-dasharray: ", ", ", ";\n      stroke-dashoffset: 0;\n    }\n    100% {\n      stroke-dasharray: ", ", ", ";\n      stroke-dashoffset: -", ";\n    }\n"])), $circumference, halfCircle, halfCircle, halfCircle, halfCircle, halfCircle, halfCircle, halfCircle);
};
var AnimatedRing = styled.circle(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  animation: ", " ", "s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n  animation-play-state: ", ";\n  transform-origin: center;\n"])), progress, DURATION, function (_ref2) {
  var $animate = _ref2.$animate;
  return $animate ? 'playing' : 'paused';
});
var getAnimationDelay = function getAnimationDelay(index) {
  var isEven = index % 2 === 0;
  var offset = isEven ? -(DURATION / 2) : 0;
  return "".concat(offset + index / 10, "s");
};
var applyAnimationDelay = function applyAnimationDelay() {
  return Array(NUMBER_OF_RINGS).fill(0).map(function (_, index) {
    return "\n        :nth-child(".concat(index + 1, ") ").concat(AnimatedRing, " {\n    animation-delay: ").concat(getAnimationDelay(index), ";\n  }");
  });
};
var applyRotationOffset = function applyRotationOffset() {
  return "\n  :nth-child(even) ".concat(AnimatedRing, " {\n    rotate: -45deg;\n  }\n  \n  :nth-child(odd) ").concat(AnimatedRing, " {\n    rotate: 135deg;\n  }\n");
};
var Root = styled.svg(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  transform-origin: center;\n\n  ", "\n  ", "\n"])), applyAnimationDelay, applyRotationOffset);

export { AnimatedRing, Root };
//# sourceMappingURL=Logo.styles.js.map
